import { useDispatch } from "react-redux";
import { CHECKOUT_PAGES_ACTION_TYPES } from "../constants/CheckoutPagesReducer";

/**
 * This hook returns `{setIsPaymentProcessing}`
 * setIsPaymentProcessing => is a function that sets the `isPaymentProcessing`
 * redux state for checkoutPages reducer
 * @mentions
 * isPaymentProcessing => checkoutPages redux state =>
 *  boolean whether the initiate booking request is successful/failed for payment
 *   true until initiateBooking for Payment Api request is fullfilled/failed
 *   false otherwise.
 * @returns `{setIsPaymentProcessing}`
 */
const useSetIsPaymentProcessing = () => {
    const dispatch = useDispatch();

    const setIsPaymentProcessing = (isProcessing: boolean) => {
        dispatch({
            type: CHECKOUT_PAGES_ACTION_TYPES.SET_IS_PAYMENT_PROCESSING,
            payload: {
                isPaymentProcessing: isProcessing,
            },
        });
    };

    return {
        setIsPaymentProcessing,
    };
};

export default useSetIsPaymentProcessing;
